module.exports = "query GetCitiesQuery($zip:String!){cities(zip:$zip){__typename edges{__typename node{__typename id value:name label:name name shipping}}}}"